@use "Styles/mixins";
@use "Styles/includes/variables";
@use "Styles/custom/related";

$shadow-size: 24px;

:host {
    display: block;
}

.vm-video-related-content {
    display: flex;
    gap: 12px;
    flex-direction: column;

    &__title {
        margin: 0;
        font-size: mixins.get-font-size(text-lg);
        line-height: mixins.get-line-height(text-lg);
        color: mixins.get-color(text, text-primary);
        font-weight: 400;

        @include mixins.desktop-and-up {
            font-size: mixins.get-font-size(text-md);
            line-height: mixins.get-line-height(text-md);
        }

        :host([hide-title-on-desktop]) & {
            @include mixins.desktop-and-up {
                display: none;
            }
        }
    }

    &__list {
        // a clamped list is cut off: mobile clips the overflow outright and the hidden items
        // are reachable through the bottom sheet, desktop scrolls to them
        &--clamped {
            height: var(--vm-video-related-content-clamp-height);
            overflow: hidden;

            @include mixins.desktop-and-up {
                overflow-y: auto;

                scrollbar-width: thin;
                scrollbar-color: mixins.get-color(border, border-primary) transparent;
            }
        }

        @include mixins.desktop-and-up {
            &--shadow-top,
            &--shadow-bottom {
                mask-image: linear-gradient(
                    to bottom,
                    var(--vm-video-related-content-shadow-top, #000),
                    #000 $shadow-size,
                    #000 calc(100% - #{$shadow-size}),
                    var(--vm-video-related-content-shadow-bottom, #000)
                );
            }

            &--shadow-top {
                --vm-video-related-content-shadow-top: transparent;
            }

            &--shadow-bottom {
                --vm-video-related-content-shadow-bottom: transparent;
            }
        }
    }

    &__list-inner,
    &__sheet-list {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    &__list-inner {
        ::slotted(vm-video-card-related:not(:first-child)) {
            padding-top: 16px;
            border-top: solid 1px;
            border-color: mixins.get-color(border, border-secondary);
        }

        @include mixins.desktop-and-up {
            ::slotted(vm-video-card-related:not(:first-child)) {
                padding-top: unset;
                border-top: unset;
            }
        }
    }

    &__cta {
        width: 100%;

        &::part(button) {
            @include mixins.desktop-and-up {
                border: none;
            }
        }
    }

    &__sheet-cta {
        width: 100%;
        margin-top: 16px;
    }
}
